"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render(_c, _vm) {
  return _c('div', {
    staticClass: "kiwi-messagelist-message kiwi-messagelist-message--text",
    class: [`kiwi-messagelist-message-${_vm.props.message.type}`, _vm.props.message.type_extra ? `kiwi-messagelist-message-${_vm.props.message.type}-${_vm.props.message.type_extra}` : '', _vm.props.ml.isMessageHighlight(_vm.props.message) ? 'kiwi-messagelist-message--highlight' : '', _vm.props.ml.isHoveringOverMessage(_vm.props.message) ? 'kiwi-messagelist-message--hover' : '', _vm.props.ml.buffer.last_read && _vm.props.message.time > _vm.props.ml.buffer.last_read ? 'kiwi-messagelist-message--unread' : '', _vm.props.message.nick.toLowerCase() === _vm.props.ml.ourNick.toLowerCase() ? 'kiwi-messagelist-message--own' : '', _vm.props.ml.message_info_open === _vm.props.message ? 'kiwi-messagelist-message--info-open' : '', _vm.props.ml.message_info_open && _vm.props.ml.message_info_open !== _vm.props.message ? 'kiwi-messagelist-message--blur' : '', _vm.props.message.pending ? 'kiwi-messagelist-message--pending' : '', _vm.props.message.send_failed ? 'kiwi-messagelist-message--send-failed' : '', _vm.props.message.user && _vm.props.m().userMode(_vm.props.message.user) ? `kiwi-messagelist-message--user-mode-${_vm.props.m().userMode(_vm.props.message.user)}` : '', _vm.data.staticClass],
    attrs: {
      "data-message-id": _vm.props.message.id,
      "data-nick": (_vm.props.message.nick || '').toLowerCase()
    },
    on: {
      "click": function ($event) {
        return _vm.props.ml.onMessageClick($event, _vm.props.message, true);
      },
      "dblclick": function ($event) {
        return _vm.props.ml.onMessageDblClick($event, _vm.props.message);
      }
    }
  }, [_c('div', [_vm.props.ml.bufferSetting('show_timestamps') ? _c('span', {
    staticClass: "kiwi-messagelist-time"
  }, [_vm._v(" " + _vm._s(_vm.props.ml.formatTime(_vm.props.message.time)) + " ")]) : _vm._e(), _c('span', {
    class: ['kiwi-messagelist-nick', _vm.props.message.user && _vm.props.m().userMode(_vm.props.message.user) ? `kiwi-messagelist-nick--mode-${_vm.props.m().userMode(_vm.props.message.user)}` : ''],
    style: {
      color: _vm.props.ml.userColour(_vm.props.message.user)
    },
    attrs: {
      "data-nick": (_vm.props.message.nick || '').toLowerCase()
    },
    on: {
      "mouseover": function ($event) {
        _vm.props.ml.hover_nick = _vm.props.message.nick.toLowerCase();
      },
      "mouseout": function ($event) {
        _vm.props.ml.hover_nick = '';
      }
    }
  }, [_c('span', {
    staticClass: "kiwi-messagelist-nick--prefix"
  }, [_vm._v(" " + _vm._s(_vm.props.message.user ? _vm.props.m().userModePrefix(_vm.props.message.user) : '') + " ")]), _c('a', {
    attrs: {
      "data-nick": (_vm.props.message.nick || '').toLowerCase()
    }
  }, [_vm._v(" " + _vm._s(_vm.props.m().displayNick()) + " ")])]), _vm.props.message.bodyTemplate && _vm.props.message.bodyTemplate.$el && _vm.props.ml.isTemplateVue(_vm.props.message.bodyTemplate) ? _c('div', {
    directives: [{
      name: "rawElement",
      rawName: "v-rawElement",
      value: _vm.props.message.bodyTemplate.$el,
      expression: "props.message.bodyTemplate.$el"
    }],
    staticClass: "kiwi-messagelist-body"
  }) : _vm.props.message.bodyTemplate ? _c(_vm.props.message.bodyTemplate, _vm._b({
    tag: "component",
    staticClass: "kiwi-messagelist-body",
    attrs: {
      "buffer": _vm.props.ml.buffer,
      "message": _vm.props.message,
      "idx": _vm.props.idx,
      "ml": _vm.props.ml
    }
  }, 'component', _vm.props.message.bodyTemplateProps, false)) : _c('div', {
    staticClass: "kiwi-messagelist-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ml.formatMessage(_vm.props.message))
    }
  }), _vm.props.message.show_pending && !_vm.props.message.send_failed ? _c('span', {
    staticClass: "kiwi-messagelist-sendcheck kiwi-messagelist-sendcheck--pending",
    attrs: {
      "role": "img",
      "aria-label": _vm.props.ml.$t('message_sending'),
      "title": _vm.props.ml.$t('message_sending')
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })]) : _vm.props.message.just_confirmed && !_vm.props.message.send_failed ? _c('span', {
    staticClass: "kiwi-messagelist-sendcheck kiwi-messagelist-sendcheck--sent",
    attrs: {
      "role": "img",
      "aria-label": _vm.props.ml.$t('message_delivered'),
      "title": _vm.props.ml.$t('message_delivered')
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()], 1), _vm.props.message.send_failed ? _c('div', {
    staticClass: "kiwi-messagelist-sendstatus"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.props.ml.$t('message_not_sent')) + " "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.props.m().resendMessage(_vm.props.message);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.props.ml.$t('message_resend')) + " ")])]) : _vm._e(), _vm.props.ml.message_info_open === _vm.props.message ? _c(_vm.injections.components.MessageInfo, {
    tag: "component",
    attrs: {
      "message": _vm.props.message,
      "buffer": _vm.props.ml.buffer
    },
    on: {
      "close": function ($event) {
        return _vm.props.ml.toggleMessageInfo();
      }
    }
  }) : _vm._e(), _vm.props.message.embed.payload && _vm.props.ml.shouldAutoEmbed ? _c('div', [_c(_vm.injections.components.MediaViewer, {
    tag: "component",
    attrs: {
      "url": _vm.props.message.embed.payload,
      "show-pin": true
    },
    on: {
      "close": function ($event) {
        _vm.props.message.embed.payload = '';
      },
      "pin": function ($event) {
        return _vm.props.ml.openEmbedInPreview(_vm.props.message);
      }
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];